import { get } from 'lodash';
import { useContext, useMemo } from 'react';
import { useRouteMatch } from 'react-router-dom';
import { SalesChannelEditorWsContext } from 'src/layout/SalesChannelEditorLayout/SalesChannelEditorLayout';
import { salesChannelRoutes } from 'src/tools/urlMap';
const urlSet = [
  salesChannelRoutes.salesChannelEditorHomepage,
  salesChannelRoutes.salesChannelEditor404Page,
  salesChannelRoutes.salesChannelEditorProductSearch,
  salesChannelRoutes.salesChannelEditorContentPageList,
  salesChannelRoutes.salesChannelContentPageEditorPage,
  salesChannelRoutes.salesChannelEditorTabbar,
  salesChannelRoutes.salesChannelEditorShoppingCartPage,
  salesChannelRoutes.salesChannelEditorPromotion,
  salesChannelRoutes.salesChannelEditorProfilePage,
  salesChannelRoutes.salesChannelEditorAllProductPage,
  salesChannelRoutes.salesChannelAppearanceEditorPage,
  salesChannelRoutes.salesChannelEditorNavigation,
  salesChannelRoutes.salesChannelEditorHeader,
  salesChannelRoutes.salesChannelEditorFooter,
  salesChannelRoutes.salesChannelEditorMegaMenu,
  salesChannelRoutes.salesChannelEditorAnimation,
  salesChannelRoutes.salesChannelEditorButton,
  salesChannelRoutes.salesChannelEditorText,
];
const useGetCurrentEditingUsr = () => {
  const { path } = useRouteMatch();
  const data = useContext(SalesChannelEditorWsContext);
  const users = get(data, 'pageEditors') || [];
  const processedUsers = useMemo(() => {
    const arr = [];
    const _users = users.map((i) => {
      const userName = get(i, 'userName');
      if (userName) {
        const arr = userName.split(' ');
        const name = arr.map((i: any) => {
          const f = (i || '').substr(0, 1);
          return f;
        });
        return { ...i, processedName: name.join('') };
      }
      return { ...i, processedName: userName };
    });
    return _users.filter((i) => {
      const userId = get(i, 'userId');
      const isExisting = arr.includes(userId);
      if (isExisting) {
        return false;
      } else {
        arr.push(userId);
        return true;
      }
    });
  }, [users]);
  const isInEditPage = urlSet.includes(path);
  if (isInEditPage) {
    return {
      users: processedUsers,
    };
  } else {
    return {
      users: [],
    };
  }
};
export { useGetCurrentEditingUsr };
